import { render } from "./TextSettings.vue?vue&type=template&id=61fa57d0"
import script from "./TextSettings.vue?vue&type=script&lang=js"
export * from "./TextSettings.vue?vue&type=script&lang=js"

import "./TextSettings.vue?vue&type=style&index=0&id=61fa57d0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__